
export const toothNumbers = [
    18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28,
    48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38,
];

export const TOOTH_ACTIONS = [
    { value: 'implant', label: 'Implant', color: '#2db7f5' },
    { value: 'lost', label: 'Đã mất', color: '#ff4d4f' },
    { value: 'crown', label: 'Chụp sứ', color: '#faad14' },
    { value: 'bridge', label: 'Cầu răng', color: '#722ed1' },
    { value: 'decay', label: 'Sâu răng', color: '#13c2c2' },
    { value: 'pulpitis', label: 'Viêm tủy', color: '#eb2f96' },
    { value: 'fracture', label: 'Mẻ răng', color: '#a0d911' },
    { value: 'abrasion', label: 'Mòn cổ', color: '#fa541c' },
    { value: 'broken_tooth', label: 'Vỡ răng', color: '#f5222d' },
    { value: 'tooth_fracture', label: 'Gãy răng', color: '#cf1322' },
    { value: 'cracked_tooth', label: 'Nứt răng', color: '#d46b08' },
    { value: 'loose_tooth', label: 'Lung lay', color: '#08979c' },
    { value: 'bone_loss', label: 'Tiêu xương', color: '#8c8c8c' },
    { value: 'super_eruption', label: 'Trồi răng', color: '#36cfc9' },
    { value: 'tilt_inward', label: 'Lệch trong', color: '#597ef7' },
    { value: 'tilt_outward', label: 'Lệch ngoài', color: '#9254de' },
    { value: 'dental_abscess', label: 'Áp xe', color: '#ff7875' },
    { value: 'tooth_collapse', label: 'Bị đổ', color: '#bfbfbf' },
    { value: 'root_canal_treated', label: 'Đã ĐTT', color: '#52c41a' },
];